/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-bgpositionshorthand-bgpositionxy-bgrepeatspace_bgrepeatround-bgsizecover-borderradius-cssanimations-csscalc-cssremunit-csstransforms-csstransforms3d-csstransitions-flexbox-flexboxtweener-fontface-inlinesvg-localstorage-preserve3d-sessionstorage-smil-svgclippaths-svgfilters-svgforeignobject-websqldatabase-setclasses !*/
!function (e, t, n) {
  function r(e, t) {
    return typeof e === t
  }

  function s() {
    var e, t, n, s, o, a, i;
    for (var l in w) if (w.hasOwnProperty(l)) {
      if (e = [], t = w[l], t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length)) for (n = 0; n < t.options.aliases.length; n++) e.push(t.options.aliases[n].toLowerCase());
      for (s = r(t.fn, "function") ? t.fn() : t.fn, o = 0; o < e.length; o++) a = e[o], i = a.split("."), 1 === i.length ? Modernizr[i[0]] = s : (!Modernizr[i[0]] || Modernizr[i[0]] instanceof Boolean || (Modernizr[i[0]] = new Boolean(Modernizr[i[0]])), Modernizr[i[0]][i[1]] = s), S.push((s ? "" : "no-") + i.join("-"))
    }
  }

  function o(e) {
    var t = T.className, n = Modernizr._config.classPrefix || "";
    if (b && (t = t.baseVal), Modernizr._config.enableJSClass) {
      var r = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
      t = t.replace(r, "$1" + n + "js$2")
    }
    Modernizr._config.enableClasses && (t += " " + n + e.join(" " + n), b ? T.className.baseVal = t : T.className = t)
  }

  function a() {
    return "function" != typeof t.createElement ? t.createElement(arguments[0]) : b ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments)
  }

  function i() {
    var e = t.body;
    return e || (e = a(b ? "svg" : "body"), e.fake = !0), e
  }

  function l(e, n, r, s) {
    var o, l, d, c, u = "modernizr", f = a("div"), p = i();
    if (parseInt(r, 10)) for (; r--;) d = a("div"), d.id = s ? s[r] : u + (r + 1), f.appendChild(d);
    return o = a("style"), o.type = "text/css", o.id = "s" + u, (p.fake ? p : f).appendChild(o), p.appendChild(f), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(t.createTextNode(e)), f.id = u, p.fake && (p.style.background = "", p.style.overflow = "hidden", c = T.style.overflow, T.style.overflow = "hidden", T.appendChild(p)), l = n(f, e), p.fake ? (p.parentNode.removeChild(p), T.style.overflow = c, T.offsetHeight) : f.parentNode.removeChild(f), !!l
  }

  function d(e, t) {
    return !!~("" + e).indexOf(t)
  }

  function c(e) {
    return e.replace(/([a-z])-([a-z])/g, function (e, t, n) {
      return t + n.toUpperCase()
    }).replace(/^-/, "")
  }

  function u(e, t) {
    return function () {
      return e.apply(t, arguments)
    }
  }

  function f(e, t, n) {
    var s;
    for (var o in e) if (e[o] in t) return n === !1 ? e[o] : (s = t[e[o]], r(s, "function") ? u(s, n || t) : s);
    return !1
  }

  function p(e) {
    return e.replace(/([A-Z])/g, function (e, t) {
      return "-" + t.toLowerCase()
    }).replace(/^ms-/, "-ms-")
  }

  function g(t, n, r) {
    var s;
    if ("getComputedStyle" in e) {
      s = getComputedStyle.call(e, t, n);
      var o = e.console;
      if (null !== s) r && (s = s.getPropertyValue(r)); else if (o) {
        var a = o.error ? "error" : "log";
        o[a].call(o, "getComputedStyle returning null, its possible modernizr test results are inaccurate")
      }
    } else s = !n && t.currentStyle && t.currentStyle[r];
    return s
  }

  function m(t, r) {
    var s = t.length;
    if ("CSS" in e && "supports" in e.CSS) {
      for (; s--;) if (e.CSS.supports(p(t[s]), r)) return !0;
      return !1
    }
    if ("CSSSupportsRule" in e) {
      for (var o = []; s--;) o.push("(" + p(t[s]) + ":" + r + ")");
      return o = o.join(" or "), l("@supports (" + o + ") { #modernizr { position: absolute; } }", function (e) {
        return "absolute" == g(e, null, "position")
      })
    }
    return n
  }

  function v(e, t, s, o) {
    function i() {
      u && (delete V.style, delete V.modElem)
    }

    if (o = r(o, "undefined") ? !1 : o, !r(s, "undefined")) {
      var l = m(e, s);
      if (!r(l, "undefined")) return l
    }
    for (var u, f, p, g, v, h = ["modernizr", "tspan", "samp"]; !V.style && h.length;) u = !0, V.modElem = a(h.shift()), V.style = V.modElem.style;
    for (p = e.length, f = 0; p > f; f++) if (g = e[f], v = V.style[g], d(g, "-") && (g = c(g)), V.style[g] !== n) {
      if (o || r(s, "undefined")) return i(), "pfx" == t ? g : !0;
      try {
        V.style[g] = s
      } catch (y) {
      }
      if (V.style[g] != v) return i(), "pfx" == t ? g : !0
    }
    return i(), !1
  }

  function h(e, t, n, s, o) {
    var a = e.charAt(0).toUpperCase() + e.slice(1), i = (e + " " + R.join(a + " ") + a).split(" ");
    return r(t, "string") || r(t, "undefined") ? v(i, t, s, o) : (i = (e + " " + A.join(a + " ") + a).split(" "), f(i, t, n))
  }

  function y(e, t, r) {
    return h(e, n, n, t, r)
  }

  var S = [], w = [], x = {
    _version: "3.6.0",
    _config: {classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0},
    _q: [],
    on: function (e, t) {
      var n = this;
      setTimeout(function () {
        t(n[e])
      }, 0)
    },
    addTest: function (e, t, n) {
      w.push({name: e, fn: t, options: n})
    },
    addAsyncTest: function (e) {
      w.push({name: null, fn: e})
    }
  }, Modernizr = function () {
  };
  Modernizr.prototype = x, Modernizr = new Modernizr, Modernizr.addTest("localstorage", function () {
    var e = "modernizr";
    try {
      return localStorage.setItem(e, e), localStorage.removeItem(e), !0
    } catch (t) {
      return !1
    }
  }), Modernizr.addTest("sessionstorage", function () {
    var e = "modernizr";
    try {
      return sessionStorage.setItem(e, e), sessionStorage.removeItem(e), !0
    } catch (t) {
      return !1
    }
  }), Modernizr.addTest("websqldatabase", "openDatabase" in e), Modernizr.addTest("svgfilters", function () {
    var t = !1;
    try {
      t = "SVGFEColorMatrixElement" in e && 2 == SVGFEColorMatrixElement.SVG_FECOLORMATRIX_TYPE_SATURATE
    } catch (n) {
    }
    return t
  });
  var T = t.documentElement, b = "svg" === T.nodeName.toLowerCase();
  Modernizr.addTest("bgpositionshorthand", function () {
    var e = a("a"), t = e.style, n = "right 10px bottom 10px";
    return t.cssText = "background-position: " + n + ";", t.backgroundPosition === n
  }), Modernizr.addTest("cssremunit", function () {
    var e = a("a").style;
    try {
      e.fontSize = "3rem"
    } catch (t) {
    }
    return /rem/.test(e.fontSize)
  }), Modernizr.addTest("preserve3d", function () {
    var t, n, r = e.CSS, s = !1;
    return r && r.supports && r.supports("(transform-style: preserve-3d)") ? !0 : (t = a("a"), n = a("a"), t.style.cssText = "display: block; transform-style: preserve-3d; transform-origin: right; transform: rotateY(40deg);", n.style.cssText = "display: block; width: 9px; height: 1px; background: #000; transform-origin: right; transform: rotateY(40deg);", t.appendChild(n), T.appendChild(t), s = n.getBoundingClientRect(), T.removeChild(t), s = s.width && s.width < 4)
  }), Modernizr.addTest("inlinesvg", function () {
    var e = a("div");
    return e.innerHTML = "<svg/>", "http://www.w3.org/2000/svg" == ("undefined" != typeof SVGRect && e.firstChild && e.firstChild.namespaceURI)
  });
  var C = x._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
  x._prefixes = C, Modernizr.addTest("csscalc", function () {
    var e = "width:", t = "calc(10px);", n = a("a");
    return n.style.cssText = e + C.join(t + e), !!n.style.length
  });
  var E = "CSS" in e && "supports" in e.CSS, _ = "supportsCSS" in e;
  Modernizr.addTest("supports", E || _);
  var z = {}.toString;
  Modernizr.addTest("svgclippaths", function () {
    return !!t.createElementNS && /SVGClipPath/.test(z.call(t.createElementNS("http://www.w3.org/2000/svg", "clipPath")))
  }), Modernizr.addTest("svgforeignobject", function () {
    return !!t.createElementNS && /SVGForeignObject/.test(z.call(t.createElementNS("http://www.w3.org/2000/svg", "foreignObject")))
  }), Modernizr.addTest("smil", function () {
    return !!t.createElementNS && /SVGAnimate/.test(z.call(t.createElementNS("http://www.w3.org/2000/svg", "animate")))
  });
  var P = x.testStyles = l, k = function () {
    var e = navigator.userAgent, t = e.match(/w(eb)?osbrowser/gi),
      n = e.match(/windows phone/gi) && e.match(/iemobile\/([0-9])+/gi) && parseFloat(RegExp.$1) >= 9;
    return t || n
  }();
  k ? Modernizr.addTest("fontface", !1) : P('@font-face {font-family:"font";src:url("https://")}', function (e, n) {
    var r = t.getElementById("smodernizr"), s = r.sheet || r.styleSheet,
      o = s ? s.cssRules && s.cssRules[0] ? s.cssRules[0].cssText : s.cssText || "" : "",
      a = /src/i.test(o) && 0 === o.indexOf(n.split(" ")[0]);
    Modernizr.addTest("fontface", a)
  });
  var N = "Moz O ms Webkit", R = x._config.usePrefixes ? N.split(" ") : [];
  x._cssomPrefixes = R;
  var A = x._config.usePrefixes ? N.toLowerCase().split(" ") : [];
  x._domPrefixes = A;
  var j = {elem: a("modernizr")};
  Modernizr._q.push(function () {
    delete j.elem
  });
  var V = {style: j.elem.style};
  Modernizr._q.unshift(function () {
    delete V.style
  }), x.testAllProps = h, x.testAllProps = y, Modernizr.addTest("cssanimations", y("animationName", "a", !0)), Modernizr.addTest("bgpositionxy", function () {
    return y("backgroundPositionX", "3px", !0) && y("backgroundPositionY", "5px", !0)
  }), Modernizr.addTest("bgrepeatround", y("backgroundRepeat", "round")), Modernizr.addTest("bgrepeatspace", y("backgroundRepeat", "space")), Modernizr.addTest("bgsizecover", y("backgroundSize", "cover")), Modernizr.addTest("borderradius", y("borderRadius", "0px", !0)), Modernizr.addTest("flexboxtweener", y("flexAlign", "end", !0)), Modernizr.addTest("flexbox", y("flexBasis", "1px", !0)), Modernizr.addTest("csstransforms", function () {
    return -1 === navigator.userAgent.indexOf("Android 2.") && y("transform", "scale(1)", !0)
  }), Modernizr.addTest("csstransforms3d", function () {
    return !!y("perspective", "1px", !0)
  }), Modernizr.addTest("csstransitions", y("transition", "all", !0)), s(), o(S), delete x.addTest, delete x.addAsyncTest;
  for (var O = 0; O < Modernizr._q.length; O++) Modernizr._q[O]();
  e.Modernizr = Modernizr
}(window, document);
